// OrdersFormComponent.tsx
import React, { useEffect, useState } from "react"
// import { useNavigate } from "react-router-dom";

import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
} from "reactstrap"
import Dropzone from "react-dropzone"
import { useFormik } from "formik"
import * as Yup from "yup"
import Select from "react-select"
import Switch from "react-switch"
import Rating from "react-rating"
import axios from "axios";
import FormUpload from "./FormUpload"
import PropTypes, { func } from "prop-types"
import { getDateString } from "helpers/common_helper"
import { post } from "helpers/api_helper"
import { creatOrder, updateOrder } from "helpers/fakebackend_helper"
import SweetAlert from "react-bootstrap-sweetalert"
import { useLocation,useHistory, useNavigate } from "react-router-dom/cjs/react-router-dom.min"
import { useDispatch } from "react-redux"


// Utility for formatting file size
const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

const MAX_FILES = 10
const MAX_FILE_SIZE_MB = 20

const OrdersFormComponent = ({ requestFor, orderRec, toggle }) => {

  const orderInitvalue = {
      orderName: "",
      po: "",
      requiredFormat: { value: '', label: '' },
      width: "", // vecort no
      height: "", // vector no
      fabric: { value: '', label: '' }, // vector no
      placement: { value: '', label: '' }, //vecotr no
      numberOfColors: "",
      blending: "No", //quote blending no
      rush: "No",
      additionalInstructions: "",
      orderByUser: "",
      orderCode: Date.now(),
      paymentStatus: false
  }
  const [alert, setAlert] = useState("");
  // const navigate = useNavigate();
  // const location = useLocation();
  // const { loading } = useSelector(state => ({
  //     loading: state.Orders.loading,
  //   }))

  const [submitting, setSubmitting] = useState(false); // NEW
  const [firebaseFiles, setFirebaseFile] = useState([]) // Add state for files
  const orderCode = Date.now();
  const [isUploading, setIsUploading] = useState(false);

  const location = useLocation();
  const history = useHistory();

  const dispatch = useDispatch();

  const { orderData, request } = location.state || {};
  

  const vectorRequiredFormat = [
    { value: '', label: 'Select Format' },
    { label: "cdr", value: "cdr" },
    { label: "ai", value: "ai" },
    { label: "eps", value: "eps" },
    { label: "other", value: "other" }
  ]

  const requiredFormatOptions = [
    { value: '', label: 'Select Format' },
    { value: '100', label: '100' },
    { value: 'cnd', label: 'cnd' },
    { value: 'dsb', label: 'dsb' },
    { value: 'dst', label: 'dst' },
    { value: 'dsz', label: 'dsz' },
    { value: 'emb', label: 'emb' },
    { value: 'exp', label: 'exp' },
    { value: 'jef', label: 'jef' },
    { value: 'ksm', label: 'ksm' },
    { value: 'pes', label: 'pes' },
    { value: 'pof', label: 'pof' },
    { value: 'tap', label: 'tap' },
    { value: 'xxx', label: 'xxx' },
    { value: 'other', label: 'other' },
  ];

  const fabricOptions = [
    { value: '', label: 'Select Fabric' },
    { value: 'Pique', label: 'Pique' },
    { value: 'Single Jersey', label: 'Single Jersey' },
    { value: 'Cotton Woven', label: 'Cotton Woven' },
    { value: 'Denim', label: 'Denim' },
    { value: 'Silk', label: 'Silk' },
    { value: 'Polyester', label: 'Polyester' },
    { value: 'Twill', label: 'Twill' },
    { value: 'Flannel', label: 'Flannel' },
    { value: 'Fleece', label: 'Fleece' },
    { value: 'Towel', label: 'Towel' },
    { value: 'Leather', label: 'Leather' },
    { value: 'Other', label: 'Other' },
  ];

  const placementOptions = [
    { value: '', label: 'Select Placement' },
    { value: 'Cap', label: 'Cap' },
    { value: 'Chest', label: 'Chest' },
    { value: 'Gloves', label: 'Gloves' },
    { value: 'Cap Side', label: 'Cap Side' },
    { value: 'Cap Back', label: 'Cap Back' },
    { value: 'Towel', label: 'Towel' },
    { value: 'JacketBack', label: 'JacketBack' },
    { value: 'Sleeve', label: 'Sleeve' },
    { value: 'Other', label: 'Other' },
  ];
  

  const validationSchema = Yup.object().shape({
    orderName: Yup.string().required("Order Name is required"),
    // po: Yup.string().required("PO is required"),
    requiredFormat: Yup.object()
      .nullable()
      .required("Required format is required"),
    width: Yup.number()
      .typeError("Width must be a number")
      .positive("Width must be positive"),
    // .required("Width is required"),
    height: Yup.number()
      .typeError("Height must be a number")
      .positive("Height must be positive"),
    // .required("Height is required"),
    fabric: Yup.object()
      .nullable(),
    // .required("Fabric is required"),
    placement: Yup.object()
      .nullable(),
    // .required("Placement is required"),
    numberOfColors: Yup.string()
      .matches(/^\d+$/, "Number of colors must be numeric"),
    // .required("Number of colors is required"),
    blending: Yup.string()
      .oneOf(["Yes", "No", "Not Sure"], "Invalid selection")
      .required("Please select if blending is required"),
    rush: Yup.string()
      .oneOf(["Yes", "No"], "Invalid selection")
      .required("Please select if it's a rush order"),
    additionalInstructions: Yup.string().max(1000, "Too long"),
    // attachment1: Yup.mixed().required("Attachment 1 is required"),
    // attachment2: Yup.mixed(),
  })

  

  const formik = useFormik({
    // enableReinitialize:true,
    initialValues: orderInitvalue,

    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setSubmitting(true); // Set submitting state to true
      values.fabric = values.fabric.value
      values.placement = values.placement.value
      values.requiredFormat = values.requiredFormat.value

      values.requestFor = requestFor.toLowerCase();
      values.submitDateTime = new Date();

      values.userEmail = orderRec?.email,
      values.userName = orderRec?.userName
      values.assToSalesMan = orderRec?.assToSalesMan
      console.log("Submitting form with values:", orderRec);


        await handleSubmit(values, resetForm); // ✅ create new
        formik.setValues({ ...orderInitvalue, orderCode: Date.now() }); // Reset orderCode for new order
      setSubmitting(false);
    },
  })

  const handleFileChange = (files) => {
    const formattedFiles = files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
  }


  const handleSubmit = async (formData, resetForm) => {


    const filesArray = Object.entries(firebaseFiles).map(([name, url]) => ({
      fileName: name,
      uploadfileName: url,
    }));

    formData.fls = JSON.stringify(filesArray);
    const result = filesArray.reduce((acc, file, index) => {
      acc[`fileName${index + 1 === 1 ? "" : index + 1}`] = file.fileName;
      acc[`uploadfileName${index + 1 === 1 ? "" : index + 1}`] =
        file.uploadfileName;
      return acc;
    }, {});

    const mergedFormData = { ...formData, ...result };

    try {
      // const res = {orderData: { orderCode: "12345" }};
      let response;
      if(request == "edit"){
        mergedFormData._id = orderData._id
       response = await updateOrder(mergedFormData).then(res => res)
       history.replace(location.pathname, {});
      }else if (request === "reOrder"){
        mergedFormData.ReplicaOrderCode = orderData.orderCode
        response = await creatOrder(mergedFormData).then(res => res);
        history.replace(location.pathname, {});
      }else{
        response = await creatOrder(mergedFormData).then(res => res);
      }
      
      if(response.success){
        setAlert(
        <SweetAlert
          success
          title="Order Successful!"
          confirmBtnText="OK"
          onConfirm={() => { setAlert(null), toggle() }}
          onCancel={() => { setAlert(null) }}
        >
          <p>Your order has been placed successfully. Your Order No is {response?.data?.orderCode}</p>
        </SweetAlert>
      );
      // navigate(location.pathname, { replace: true, state: {} });
 
      
      // resetForm(); // Reset the form after successful submission
      setSubmitting(false); // Reset submitting state
      // selectedFiles.forEach((file) => URL.revokeObjectURL(file.preview));
      // setSelectedFiles([]); // ✅ Clear files
      formik.resetForm({ ...orderInitvalue, orderCode: Date.now() })
      }
      
    } catch (err) {
      console.error(err);
      setSubmitting(false);
      alert("Failed to create order");
      return err;
    }
  };



  const handleUpload = (downloadURL, name) => {
    // You can handle the uploaded file URL here if needed
    setFirebaseFile(prev => ({ ...prev, [name]: downloadURL }));

    // conssole.log("File uploaded to:", downloadURL);
  }
  useEffect(() => {
    if (request === "edit" || request === "reOrder") {
      formik.setValues({
        ...formik.values,          // keep defaults
        orderName: orderData?.orderName || "",
        po: orderData?.po || "",
        requiredFormat: orderData?.requiredFormat
          ? { value: orderData.requiredFormat, label: orderData.requiredFormat }
          : { value: "", label: "" },
        width: orderData?.width || "",
        height: orderData?.height || "",
        fabric: orderData?.fabric
          ? { value: orderData.fabric, label: orderData.fabric }
          : { value: "", label: "" },
        placement: orderData?.placement
          ? { value: orderData.placement, label: orderData.placement }
          : { value: "", label: "" },
        numberOfColors: orderData?.numberOfColors || "",
        blending: orderData?.blending || "No",
        rush: orderData?.rush || "No",
        additionalInstructions: orderData?.additionalInstructions || "",
        orderByUser: orderData?.orderByUser || "",
        orderCode: request === "reOrder" ? Date.now() : orderData?.orderCode || Date.now(),
        paymentStatus: request === "reOrder" ? false : orderData?.paymentStatus || false,
      });
    }
  }, [request, orderData]);

  return (
    <Form onSubmit={formik.handleSubmit}>
      {alert}
      <FormGroup row>
        <Label className="col-lg-3 col-form-label">Order Name:</Label>
        <Col lg="9">
          <Input
            type="text"
            name="orderName"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.orderName}
            className={formik.touched.orderName && formik.errors.orderName ? "is-invalid" : ""}
          />
          {formik.touched.orderName && formik.errors.orderName && (
            <div className="invalid-feedback">{formik.errors.orderName}</div>
          )}
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label className="col-lg-3 col-form-label">PO:</Label>
        <Col lg="9">
          <Input
            type="text"
            name="po"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.po}
            className={formik.touched.po && formik.errors.po ? "is-invalid" : ""}
          />
          {formik.touched.po && formik.errors.po && (
            <div className="invalid-feedback">{formik.errors.po}</div>
          )}
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label className="col-lg-3 col-form-label">Required Format</Label>
        <Col lg="9">
          <Select
            name="requiredFormat"
            transition
            options={requestFor === "Order" || requestFor === "Quote" ? requiredFormatOptions : vectorRequiredFormat}
            value={formik.values.requiredFormat}
            onChange={(value) => formik.setFieldValue('requiredFormat', value)}
            onBlur={() => formik.setFieldTouched('requiredFormat', true)}
          />
          {formik.touched.requiredFormat && formik.errors.requiredFormat && (
            <div className="invalid-feedback d-block">{formik.errors.requiredFormat}</div>
          )}
        </Col>
      </FormGroup>

      {requestFor != "Vector" ?
        (<>
          <FormGroup row>
            <Label className="col-lg-3 col-form-label">Dimensions (Inches):</Label>
            <Col lg="9">
              <Row>
                <Col lg={6}>
                  <Input
                    type="number"
                    name="width"
                    placeholder="Width"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.width}
                    className={formik.touched.width && formik.errors.width ? "is-invalid" : ""}
                  />
                  {formik.touched.width && formik.errors.width && (
                    <div className="invalid-feedback">{formik.errors.width}</div>
                  )}
                </Col>
                <Col lg={6}>
                  <Input
                    type="number"
                    name="height"
                    placeholder="Height"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.height}
                    className={formik.touched.height && formik.errors.height ? "is-invalid" : ""}
                  />
                  {formik.touched.height && formik.errors.height && (
                    <div className="invalid-feedback">{formik.errors.height}</div>
                  )}
                </Col>
              </Row>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label className="col-lg-3 col-form-label">Fabric</Label>
            <Col lg="9">
              <Select
                name="fabric"
                transition
                options={fabricOptions}
                value={formik.values.fabric}
                onChange={(value) => formik.setFieldValue('fabric', value)}
                onBlur={() => formik.setFieldTouched('fabric', true)}
              />
              {formik.touched.fabric && formik.errors.fabric && (
                <div className="invalid-feedback d-block">{formik.errors.fabric}</div>
              )}
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label className="col-lg-3 col-form-label">Placement</Label>
            <Col lg="9">
              <Select
                name="placement"
                options={placementOptions}
                value={formik.values.placement}
                onChange={(value) => formik.setFieldValue('placement', value)}
                onBlur={() => formik.setFieldTouched('placement', true)}
              />
              {formik.touched.placement && formik.errors.placement && (
                <div className="invalid-feedback d-block">{formik.errors.placement}</div>
              )}
            </Col>
          </FormGroup>
        </>) : ""}
      <FormGroup row>
        <Label className="col-lg-3 col-form-label">Number of Colors:</Label>
        <Col lg="9">
          <Input
            type="text"
            name="numberOfColors"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.numberOfColors}
            className={formik.touched.numberOfColors && formik.errors.numberOfColors ? "is-invalid" : ""}
          />
          {formik.touched.numberOfColors && formik.errors.numberOfColors && (
            <div className="invalid-feedback">{formik.errors.numberOfColors}</div>
          )}
        </Col>
      </FormGroup>

      {requestFor != "Quote" ?
        (
          <FormGroup row>
            <Label className="col-lg-3 col-form-label">Do You Require Blending?</Label>
            <Col lg="9">
              {['Yes', 'No', 'Not Sure'].map((option) => (
                <FormGroup check inline key={option}>
                  <Label check>
                    <Input
                      type="radio"
                      name="blending"
                      value={option}
                      checked={formik.values.blending === option}
                      onChange={() => formik.setFieldValue('blending', option)}
                      onClick={() => formik.setFieldValue('blending', option)}
                      onBlur={() => formik.setFieldTouched('blending', true)}
                    />{' '}
                    {option}
                  </Label>
                </FormGroup>
              ))}
              {formik.touched.blending && formik.errors.blending && (
                <div className="invalid-feedback d-block">{formik.errors.blending}</div>
              )}
            </Col>
          </FormGroup>
        ) : ""
      }
      <FormGroup row>
        <Label className="col-lg-3 col-form-label">Do You Need This Order as a Rush?</Label>
        <Col lg="9">
          {['Yes', 'No'].map((option) => (
            <FormGroup check inline key={option}>
              <Label check>
                <Input
                  type="radio"
                  name="rush"
                  value={option}
                  checked={formik.values.rush === option}
                  onChange={() => formik.handleChange}
                  onClick={() => formik.setFieldValue('rush', option)}
                // onBlur={() => formik.setFieldTouched('rush', true)}
                />{' '}
                {option}
              </Label>
            </FormGroup>
          ))}
          {formik.touched.rush && formik.errors.rush && (
            <div className="invalid-feedback d-block">{formik.errors.rush}</div>
          )}
        </Col>
      </FormGroup>



      <FormGroup row>
        <Label className="col-lg-3 col-form-label">Additional Instructions:</Label>
        <Col lg="9">
          <Input
            type="textarea"
            name="additionalInstructions"
            rows="3"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.additionalInstructions}
            className={
              formik.touched.additionalInstructions && formik.errors.additionalInstructions
                ? "is-invalid"
                : ""
            }
          />
          {formik.touched.additionalInstructions && formik.errors.additionalInstructions && (
            <div className="invalid-feedback">{formik.errors.additionalInstructions}</div>
          )}
        </Col>
      </FormGroup>


      <FormGroup row>
        <Label className="col-lg-3 col-form-label">Attachment:</Label>
        <Col lg="9">
          <Row>
            <Col className="col-12">
              <FormUpload orderData={orderData} onFileChange={handleFileChange} handleUpload={handleUpload} orderCode={orderCode} fileLimit={2} onUploadStatusChange={setIsUploading} />
            </Col>
          </Row>
        </Col>
      </FormGroup>

      <Row className="justify-content-end">
        <Col lg="3">
          <Button
            color="primary"
            type="submit"
            disabled={isUploading || submitting}   // ✅ Disable while uploading or submitting
          >
            {submitting ? "Submitting..." : "Submit"}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

OrdersFormComponent.propTypes = {
  requestFor: PropTypes.string,
  orderRec: PropTypes.object,
  toggle: PropTypes.func
}

export default OrdersFormComponent
